import type { IconData } from '@stacksjs/iconify-core'

export const disableProtection: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M37.5 37.585c4.685-4.539 7.34-10.955 7.34-17.694a101 101 0 0 0-.654-11.427c-.191-1.647-1.19-3.007-2.81-3.365C38.85 4.54 33.954 3.89 24.84 3.89s-14.01.65-16.536 1.208A3.4 3.4 0 0 0 6.5 6.138M5.152 12a102 102 0 0 0-.312 7.891c0 9.029 4.765 17.477 12.792 21.608c2.682 1.38 5.3 2.392 7.208 2.392s4.526-1.012 7.207-2.392q.618-.318 1.21-.67M3 3l40 40\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default disableProtection
